import { Helmet } from "react-helmet";
import Hero from "../../components/sections/Hero";

const Section = ({ title, children }) => (
  <div className="flex flex-col">
    <header className="text-center px-4">
      <h1 className="text-gold text-3xl">{title}</h1>
    </header>
    {children}
  </div>
);

export default function Baseball() {
  const drivesContent = [
    {
      title: "",
      body: (
        <p>
          <strong className="text-white">Drives Baseball</strong> brings new
          precision to baseball by quantifying the scoring potential of every
          half-inning in real time. Whether it’s the first pitch or a two-out
          rally, Drives measures how each moment shifts run expectancy — turning
          baseball’s pacing into a continuous, tradable experience.
        </p>
      ),
    },
    {
      children: <Hero subTitle="Watch the Drives Baseball Out-by-Out Demo" />,
    },
    {
      title: "From Past to Present",
      body: `Traditional baseball stats explain what happened. Drives reflects expectations on what’s about to happen. By translating each pitch, at-bat, and baserunning decision into real-time scoring potential, Drives gives fans and bettors a fresh lens to watch the game — not just by outcome, but by opportunity.`,
    },
    {
      title: "Run Expectancy, Reimagined",
      body: (
        <>
          <p>
            The <strong>Drives Score</strong> tracks expected runs for a
            half-inning, adjusting after every change in game state — factoring
            in inning, outs, runners, and more.
          </p>
          <p>
            <strong>Drives Score Added (DSA)</strong> captures the swing in
            scoring potential of each moment. A single? Helpful. A bases-loaded
            walk with two outs? Game-changing. DSA quantifies that impact pitch
            by pitch.
          </p>
          <div>
            <p>Our analytics identify:</p>
            <ul className="list-disc text-left mt-3 w-full">
              <li>The impact of each pitch and play</li>
              <li>High-leverage at-bats that define games</li>
              <li>Situational efficiency — who delivers when it counts</li>
            </ul>
          </div>
          <p className="mt-3">
            The result: deeper commentary, sharper predictive signals, and
            real-time context for betting decisions.
          </p>
        </>
      ),
    },
    {
      title: "Betting the Inning: The Drives Betting Model",
      body: (
        <>
          <p>
            Drives transforms baseball’s natural pacing into live market windows
          </p>
          <ul className="list-disc text-left w-full">
            <li>
              <strong className="text-gold">Inning-by-Inning Markets:</strong>{" "}
              Users can buy or sell the Drives Score at any point — mid-inning,
              mid-count, mid-comeback.
            </li>
            <li>
              <strong className="text-gold">Dynamic Pricing:</strong> Odds shift
              with each pitch, shaped by crowd behavior and in-game events.
            </li>
            <li>
              <strong className="text-gold">
                Data-Fueled Decision Making:
              </strong>{" "}
              Every market is backed by situational scoring models — giving
              bettors real-time intelligence, not just vibes.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "Why Baseball is Built for Drives",
      body: `With its stop-start structure and constant recalibration of pressure, baseball naturally suits real-time markets. From low-scoring duels to late-inning chaos, Drives brings clarity to the sport’s most unpredictable moments.`,
    },
  ];

  return (
    <section className="section about-section">
      <Helmet>
        <title>Baseball</title>
      </Helmet>

      <div className="flex flex-col container">
        {drivesContent.map((data, index) =>
          data.children ? (
            <div className="flex flex-col items-center">
              <div className="mt-14 pb-2">{data.children}</div>
            </div>
          ) : (
            <Section key={index} title={data.title} children={data.body} />
          )
        )}
      </div>
    </section>
  );
}
